// Generated by ReScript, PLEASE EDIT WITH CARE


function reducer(state, action) {
  switch (action.TAG | 0) {
    case /* SetReport */0 :
        return {
                report: action._0,
                request_status: state.request_status,
                rewardIds: state.rewardIds,
                banners_status: state.banners_status,
                config: state.config,
                vernacular_content: state.vernacular_content
              };
    case /* OnClaimRewardSuccess */1 :
        return {
                report: state.report,
                request_status: {
                  TAG: /* Live */1,
                  _0: action._0
                },
                rewardIds: state.rewardIds,
                banners_status: state.banners_status,
                config: state.config,
                vernacular_content: state.vernacular_content
              };
    case /* OnClaimRewardError */2 :
        return {
                report: state.report,
                request_status: {
                  TAG: /* Error */2,
                  _0: action._0
                },
                rewardIds: state.rewardIds,
                banners_status: state.banners_status,
                config: state.config,
                vernacular_content: state.vernacular_content
              };
    case /* OnClaimReward */3 :
        return {
                report: state.report,
                request_status: {
                  TAG: /* Loading */0,
                  _0: undefined
                },
                rewardIds: action._1,
                banners_status: state.banners_status,
                config: state.config,
                vernacular_content: state.vernacular_content
              };
    case /* OnBannersSuccess */4 :
        return {
                report: state.report,
                request_status: state.request_status,
                rewardIds: state.rewardIds,
                banners_status: {
                  TAG: /* Live */1,
                  _0: action._0
                },
                config: state.config,
                vernacular_content: state.vernacular_content
              };
    case /* OnBannersError */5 :
        return {
                report: state.report,
                request_status: state.request_status,
                rewardIds: state.rewardIds,
                banners_status: {
                  TAG: /* Error */2,
                  _0: action._0
                },
                config: state.config,
                vernacular_content: state.vernacular_content
              };
    case /* SetConfig */6 :
        return {
                report: state.report,
                request_status: state.request_status,
                rewardIds: state.rewardIds,
                banners_status: state.banners_status,
                config: action._0,
                vernacular_content: state.vernacular_content
              };
    case /* SetVernacularContent */7 :
        return {
                report: state.report,
                request_status: state.request_status,
                rewardIds: state.rewardIds,
                banners_status: state.banners_status,
                config: state.config,
                vernacular_content: action._0
              };
    
  }
}

var initialState = {
  report: /* Init */0,
  request_status: /* Init */0,
  rewardIds: /* [] */0,
  banners_status: /* Init */0,
  config: /* Init */0,
  vernacular_content: /* Init */0
};

export {
  initialState ,
  reducer ,
  
}
/* No side effect */
